import { PlayerService } from '@modules/player/player-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import { i18n } from '@shared/i18n';

export default {
  namespaced: true,

  state: {
    loading: false,
    inscriptions: null,
  },

  getters: {
    inscriptions: (state) => state.inscriptions,
    loading: (state) => !!state.loading,
  },

  mutations: {
    FIND_STARTED(state) {
      state.inscriptions = null;
      state.loading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.inscriptions = payload;
      state.loading = false;
    },

    FIND_ERROR(state) {
      state.inscriptions = null;
      state.loading = false;
    },
  },

  actions: {
    async doLoadInscriptions({ commit }, { id, subpropertyId, type = "subproperty" }) {
      try {
        commit('FIND_STARTED');
        
        const response = await PlayerService.inscriptions(id, { subpropertyId, type });
        const inscriptions = response.map(({id: inscriptionId, status, program: { name: programName }, subprogram: { name: subprogramName } }) => {

          return {
            title: programName,
            description: subprogramName,
            statusLayout: {
              contentText: i18n(`enumerators.inscriptionStatus.${status}`)
            },
            linkLayout: {
              contentText: i18n('entities.player.view.btns.seeDetail'),
              linkTo: { name: 'subpropertyPeopleInscriptionDetail', params: {id: inscriptionId, subpropertyId }} ,
            },
          }
        })

        commit('FIND_SUCCESS', inscriptions );
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        routerAsync().push('/player');
      }
    },
  },
};
